<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ kavTitel | mrTranslate }}</span>
    </div>

    <div class="header-actions">
      @if (ebene == 0){
        <div class="clr-form-horizontal d-f clr-align-items-center">
          <clr-select-container class="nym margin-6-r">
            <label style="width: auto; padding: 0 2px"></label>
            <select
              clrSelect
              name="objekt"
              class="cur-color"
              [(ngModel)]="kavansichtValue"
              [ngModelOptions]="{ standalone: true }">
              @for (typ of auswahl(); track typ.key) {
                <option [ngValue]="typ.key">
                  {{ typ.value }}
                </option>
              }
            </select>
          </clr-select-container>
        </div>
      }

      @if (ebene > 0){
        <a href="javascript://" class="nav-link nav-icon">
          <cds-icon
            shape="angle"
            class="rotate-90"
            (click)="goBack()">
          </cds-icon>
        </a>
      }



      <a href="javascript://" class="nav-link nav-icon" (click)="changeView()">
        @let shape = typansicht() == 0 ? 'list' : 'line-chart';
        <cds-icon [shape]="shape"/>
      </a>

      <a href="javascript://" class="nav-link nav-icon" [class.disabled]="typansicht() === 0">
        <cds-icon shape="excel" (click)="typansicht() === 1 && excelexport()"></cds-icon>
      </a>

      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>
  <div id="kavdetaildialogWrapper">
   
    @if (typansicht() == 0) {
      @if (curDiagramm().length > 0) {
        <app-plotly-plot
          [className]=""
          [data]="curDiagramm()"
          [layout]="curgraphkav.layout"
          [config]="curgraphkav.config"
          (plotlyClick)="onBarClick($event)"></app-plotly-plot>
      } 
    } @else {

      <clr-datagrid class="datagrid-compact">
        @for (column of curtable().columns; track column) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container
              *clrDgHideableColumn="{
                hidden: column.id | hideIDColumns: [],
              }">
              {{ column.id | mrTranslate | titlecase }}
            </ng-container>
          </clr-dg-column>
        }
        <clr-dg-row *clrDgItems="let row of curtable().rows" [clrDgItem]="row">
          @for (cell of curtable().columns; track cell) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        
        <clr-dg-footer>{{ curtable().rows.length }} {{ 'Zeilen' | titlecase | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>

    }
  </div>
</div>
